import { RootState } from 'store/store';

// export const getGeoLocation = (state: RootState) => state.metric.geoLocation;
export const getGuestId = (state: RootState) => state.metric.guestId;
export const getFirstTimePages = (state: RootState) => state.metric.firstTimePages;
export const getSessionId = (state: RootState) => state.metric.sessionId;
export const getLastSeen = (s: RootState) => s.metric.lastSeen;
